// extracted by mini-css-extract-plugin
export var downArrow = "_75-0";
export var infoTooltipIcon = "_75-3";
export var label = "_75-1";
export var optionCard = "_75-4";
export var upArrow = "_75-2";